import React from "react";
import { Reveal, SectionEyebrow } from "../common/Section";
import { useI18n } from "../../lib/i18n";

const PartnersMarquee = ({ partners }) => {
  const { t } = useI18n();
  if (!partners?.length) return null;
  const doubled = [...partners, ...partners];

  return (
    <section className="bg-white border-y border-black/5 py-12 md:py-16" data-testid="partners-section">
      <div className="container-x mb-10">
        <Reveal>
          <SectionEyebrow>{t("home.partners")}</SectionEyebrow>
        </Reveal>
      </div>
      <div className="overflow-hidden">
        <div className="marquee-track">
          {doubled.map((p, idx) => (
            <div
              key={`${p.name}-${idx}`}
              className="flex items-center justify-center min-w-[220px]"
              data-testid={`partner-${idx}`}
            >
              <div className="font-serif text-2xl md:text-3xl text-brand-medium hover:text-brand-navy transition-colors">
                {p.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersMarquee;
